import { fetchDataFromBackend } from "../api/api";
import {UserDTO, UserStatus} from "../DTOs/userDTO";
import logger from "../core/utils/logger";

const isSimulation= import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

// Helper to generate 100 simulated users
const generateSimulatedUsers = (count = 100) => {
    const statuses = [0, 1, 2, 3, 4, 5, 6]; // Corresponds to UserStatus enum
    const users = [];
    const currentYear = new Date().getFullYear();
   

    for (let i = 1; i <= count; i++) {
        const holidaysByYear = {};

        // Generate holiday data for 4 years (current ±1)
        for (let y = currentYear - 1; y <= currentYear + 2; y++) {
          holidaysByYear[y] = Math.floor(Math.random() * 31); // 0–30 days
        }
        const titles = ["", "Dr.", "Prof.", "Dr. med.", "Prof. Dr.", "Mr.", "Mrs.", "Ms."];
        const firstNames = ["John", "Jane", "Michael", "Sarah", "David", "Lisa", "Robert", "Emily"];
        const surnames = ["Smith", "Johnson", "Williams", "Brown", "Jones", "Garcia", "Miller", "Davis"];
        
        users.push(
            UserDTO.fromApiResponse({
                id: i,
                name: `Simulated User ${i}`,
                email: `user${i}@simulated.com`,
                organizationId: `org${(i % 5) + 1}`, // Simulate 5 different orgs
                status: statuses[i % statuses.length], // Rotate through statuses
                remainingHolidays: Math.floor(Math.random() * 30), // Random holidays
                remainingOvertime: Math.floor(Math.random() * 40), // Random overtime
                holidaysByYear,
                title: titles[i % titles.length],
                firstName: firstNames[i % firstNames.length],
                surname: surnames[i % surnames.length],
            })
        );
    }

    return users;
};


export const UserService = {
    async getUsersInOrganisationRequest() {
        try {
         
            if (isSimulation) {
                logger.log("Simulation mode enabled. Generating 100 simulated users.");
                const users = generateSimulatedUsers(100);
                return users;
            }
            const response = await fetchDataFromBackend("/user/GetUsers",{skipAuth:false, method: 'get'});
            logger.log("Users in organisation response:", response);
            const users=response.map(UserDTO.fromApiResponse);
            return users;
        }
        catch (error) {
            if (error.response) {
                // Handle known backend error response
                if (error.response.status === 404) {
                    logger.warn("🚨 API returned 404: Users not found.");
                    return []; // Return an empty array instead of throwing
                } else {
                    logger.error("❌ API Error:", error.response.data);
                }
            } else {
                logger.error("❌ Network/Unknown Error:", error);
            }

            throw error;
        }

    },
    async setUserInformation(userData) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Simulated user information update.");
                return UserDTO.fromApiResponse(userData);
            }
            //modify userData to match the backend
            userData.status = UserStatus[userData.status];

            const response = await fetchDataFromBackend("/user/SetUserInformation",{skipAuth:false, method: 'put', data: userData});
            logger.log("User information update response:", response);
            return UserDTO.fromApiResponse(response);
        }
        catch (error) {
            logger.error("❌ Error updating user information:", error);
            throw error;
        }
    },
    async deleteUser(userId) {
        try {
            if (isSimulation) {
                logger.log(`Simulation mode enabled. Simulated deletion of user ${userId}.`);
                return true;
            }
            const response = await fetchDataFromBackend(`/user/DeleteUser/${userId}`, {skipAuth:false, method: 'delete'});
            logger.log("User deletion response:", response);
            return true;
        }
        catch (error) {
            logger.error("❌ Error deleting user:", error);
            throw error;
        }
    },
    // Self-service: the signed-in user deletes their OWN account (Keycloak login
    // + app record). Backend: DELETE /user/DeleteMyAccount -> 204. Uses the
    // caller's token; no id is passed.
    async deleteOwnAccount() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Simulated own-account deletion.");
                return true;
            }
            await fetchDataFromBackend("/user/DeleteMyAccount", {skipAuth:false, method: 'delete'});
            logger.log("Own account deleted.");
            return true;
        }
        catch (error) {
            logger.error("❌ Error deleting own account:", error);
            throw error;
        }
    },

};